module.exports = __webpack_public_path__ + "img/Asset5.52dbe1bb.png";